var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail20Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 5.94958V14.2829C18.3346 14.8355 18.1151 15.3654 17.7244 15.7561C17.3337 16.1468 16.8038 16.3663 16.2513 16.3663H3.7513C3.19877 16.3663 2.66886 16.1468 2.27816 15.7561C1.88746 15.3654 1.66797 14.8355 1.66797 14.2829V5.94958",
    stroke: "#033B5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 5.94954C18.3346 5.39701 18.1151 4.86711 17.7244 4.47641C17.3337 4.0857 16.8038 3.86621 16.2513 3.86621H3.7513C3.19877 3.86621 2.66886 4.0857 2.27816 4.47641C1.88746 4.86711 1.66797 5.39701 1.66797 5.94954L8.89714 10.4634C9.22824 10.6704 9.61084 10.7801 10.0013 10.7801C10.3918 10.7801 10.7744 10.6704 11.1055 10.4634L18.3346 5.94954Z",
    stroke: "#033B5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail20Px);
export default __webpack_public_path__ + "static/media/mail-20px.1d12c806fb6ca11815fd643df99259ae.svg";
export { ForwardRef as ReactComponent };